
import { ProductClient } from "@dtos/productClient.dto";
import gateway from "@interceptors/gateway.interceptor";
import { BaseService } from "@services/base.service"

class PaymentService extends BaseService {
    
    public getAccomodationPrice = async (accomodationNumber: number, currency: string)=>{
        const url= `/product/calculate-price`
        const response = await gateway.get(url,{
            params:{
                currency: currency,
                accomodation: accomodationNumber
            }
        })
        return response.data
    }

    public getAddCreditsPrice = async (accomodationNumber: number, orderNumber: string, currency: string)=>{
 
        const url= `/product/calculate-add-credits`
        const response = await gateway.get(url, {
            params:{
                accomodationNumber: accomodationNumber,
                orderNumber: orderNumber,
                currency: currency,
            }
        })
        return response.data
    }

    public getStripeUrl = async (dto: ProductClient, currency: string)=>{
        const url= `/payment/checkout`
        const response = await gateway.post(url, dto, {
            params:{
                currency: currency,
            }
        })
        return response.data
    }

    public getStripeRenewalUrl = async (dto: ProductClient, orderNumber: string, currency: string)=>{
        const url= `/payment/checkout-renewal`
        const response = await gateway.post(url, dto, {
            params:{
                orderNumber: orderNumber,
                currency: currency
            }
        })
        return response.data
    }

    public getStripeAddCreditsUrl = async (dto: ProductClient,  orderNumber: string, currency: string)=>{
        const url= `/payment/add-credits`
        const response = await gateway.post(url, dto, {
            params:{
                orderNumber: orderNumber,
                currency: currency
            }
        })
        return response.data
    }

     public getAllCurrency = async ()=>{
        const url= `/payment/get-all-currencies`
        const response = await gateway.get(url)
        return response.data
    }

}
export default new PaymentService();